import { useEffect } from 'react';
import LandingNav from '../components/landing/LandingNav';
import LandingFooter from '../components/landing/LandingFooter';
import TrialBanner from '../components/pricing/TrialBanner';
import PricingTiers from '../components/pricing/PricingTiers';
import Boosters from '../components/pricing/Boosters';
import VerifiedLeadBox from '../components/pricing/VerifiedLeadBox';
import styles from './PricingPage.module.css';

// Public "Pricing" page. Reuses the marketing nav/footer and owns its own scroll
// container (global `body { overflow: hidden }` for the app shell).
export default function PricingPage() {
  useEffect(() => {
    document.getElementById('top')?.scrollTo({ top: 0 });
  }, []);

  return (
    <div id="top" className={styles.page}>
      <LandingNav />
      <main>
        <TrialBanner />
        <PricingTiers />
        <Boosters />
        <VerifiedLeadBox />
      </main>
      <LandingFooter />
    </div>
  );
}
